






import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      year: 0,
    };
  },
  mounted() {
    const d = new Date();
    this.year = d.getFullYear();
  },
});
